import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "option", "group"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.normalize(this.inputTarget.value)

    this.optionTargets.forEach(option => {
      const text = this.normalize(option.dataset.filterSearchText || option.textContent)
      option.hidden = query.length > 0 && !text.includes(query)
    })

    this.groupTargets.forEach(group => {
      const hasVisibleOption = Array.from(group.querySelectorAll('[data-filter-search-target="option"]')).some(o => !o.hidden)
      group.hidden = !hasVisibleOption
    })
  }

  reset() {
    this.inputTarget.value = ""
    this.filter()
  }

  normalize(value) {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase()
      .trim()
  }
}
